import ProjectCardsFactory from '@/components/projects/cards/factory/ProjectCardsFactory';
import useWinners from '@/data/hook/hackathon/useWinners';
import Hackathon from '@/models/Hackathon';
import { AnimatePresence } from 'motion/react';
import { useState } from 'react';
import TrophyCarousel from './TrophyCarousel';

type PodiumAllProps = {
  hackathon: Hackathon;
};

export default function PodiumAll({ hackathon }: PodiumAllProps) {
  const [position, setPosition] = useState(1);

  const { winnersByRank, invalidate } = useWinners(hackathon);

  return (
    <div className="w-full flex flex-col gap-3">
      <TrophyCarousel onChange={setPosition} selected={position} />
      <ul className="w-full relative flex md:justify-center items-start gap-1 overflow-x-scroll md:overflow-visible scrollbar-hide snap-x snap-mandatory">
        <AnimatePresence>
          {winnersByRank[position.toString()]?.map(winner => (
            <ProjectCardsFactory
              key={winner.category}
              mode="podium"
              project={winner.project}
              rank={winner.rank}
              onMutate={invalidate}
              className={{
                base: 'w-60 min-w-60',
              }}
            />
          ))}
        </AnimatePresence>
      </ul>
    </div>
  );
}
